var map = {
	"./12AzhkUkBYZ-p4x8Ku1aPi.svg": "36d1",
	"./15MGKlq2K_DhuqHGMT0M9H.svg": "fd61",
	"./1KtVG8Xn7Oi-FoCxa0ZdOG.svg": "2aac",
	"./1PH2sk9KKpJNYT-baEFlpw.svg": "3f6a",
	"./1b75f77a-edb6-4983-a606-09d47f2dcf51.jpg": "96d0",
	"./1nKN014l4b8s79RLsrPqL7.svg": "4ab2",
	"./1oCdDyHeiUZ65TU6RB78H4.svg": "81f3",
	"./1t4B9bQrPdx6C8Ym1mU1b-.svg": "c1a3",
	"./1wSIepCtseCVhUDwJBZcXN.svg": "f2f3",
	"./2-G_o0P0-zlS4gxoGSgx4D.svg": "ee72",
	"./276FnaspW-gic1_UQ8xkXT.svg": "4250",
	"./27zlrcb8QANKHoYh4sjTKI.svg": "46b6",
	"./28wnZrx-S9SGkbz30xcUwg.svg": "1c0e",
	"./2NQxhkZg5Uc1v1vMIZIZW3.png": "f257",
	"./2Ne-jT4Hrq0YHpqbbczTWW.png": "42b8",
	"./2g-IAwszlz0R5K7eHIFTZY.svg": "49aa",
	"./2tu3pma5HRsX4f41PeBqCa.svg": "3307",
	"./2yuI2rEeOhSQ8e7ELmvU8U.svg": "5aed",
	"./3-nYotDp1VDMyHC1jQ6AQa.png": "ef6b",
	"./30e4a2b6-4a89-4f25-b8c4-293b4af1badf-min.jpg": "7fd0",
	"./31-vgBfUeHOdkR8HXt5HP6.png": "83be",
	"./31iKawYVsldFlibQv6hKhf.svg": "c84a",
	"./33kJpde_0RX8dtkAgroCpp.png": "d0d7",
	"./373T3YQLNGHpSqNniklV-B.svg": "0f27",
	"./39bQ1s4_B8Uit750tn8fxk.svg": "e2ac",
	"./3KFKwAYgHBq6YbCiBeyMZQ.svg": "e365",
	"./3Nqr1Z4pkZt9jkR6uSrw5J.jpg": "f76f",
	"./3UuE4Zui8rA_GlKBtit9KM.png": "5c92",
	"./3dd2cE-4kJbJ9-79ZjO6ox.svg": "72e0",
	"./3iKXI4vqItbSTG94rMNyjK.svg": "0598",
	"./3mBXOvvW4gFyzEfJJnCV3f.svg": "82f9",
	"./3oWlJ8M85DdOP-2jjDfObl.png": "4ecd",
	"./3rUw5nLdRFBK92P8ztuOo.svg": "b0e7",
	"./8aWiT2hLHXqVwxfB8tf_i.svg": "70f5",
	"./9E4Kz7tHbumrXL_WJzKkl.png": "7c99",
	"./QDLOp3qTiVzuezlhsT44y.svg": "ab56",
	"./Z8YgwSSb1FZx2doc3tIH1.svg": "8c85",
	"./bussines_pointer.jpg": "6fab",
	"./connect-ed.png": "aca3",
	"./copy.svg": "f84c",
	"./f4f61c9f-735b-4fce-94e5-3b410f330694.png": "81d2",
	"./helpcenter.af.svg": "e5ba",
	"./helpcenter.fl.svg": "31d6",
	"./helpcenter.ge.svg": "7960",
	"./helpcenter.kg.svg": "b59e",
	"./helpcenter.ne.svg": "4be5",
	"./helpcenter.ng.svg": "04f1",
	"./j3oVA_71D1QCXmUIMFc-C.svg": "95f0",
	"./kLnNi5XFXIzvdyOTdNyBe.svg": "5f0f",
	"./lang-kz.svg": "aeca",
	"./lang-ru.svg": "79e3",
	"./lang-uz.svg": "3e2f",
	"./languages.svg": "027a",
	"./likes.svg": "bd89",
	"./logo_mediagoods_2020.png": "755a",
	"./logobezformata_z.jpg": "06d6",
	"./logonew.png": "3ec9",
	"./logonewkhabar.png": "db295",
	"./mobile/appstore.png": "de84",
	"./mobile/arrow.svg": "130d",
	"./mobile/content (1).svg": "c595",
	"./mobile/content (2).svg": "f177",
	"./mobile/content.svg": "bc12",
	"./mobile/googleplay.png": "ed2d",
	"./mobile/image_1.jpg": "23ca",
	"./mobile/image_2.jpg": "d555",
	"./mobile/image_3.jpg": "d2bb2",
	"./nK3LHvN3oAolx2f6joZ0m.png": "c00a",
	"./rezonans.png": "e86e",
	"./ryketC9SgLgfKcK0c6L4o.svg": "bf1c",
	"./s66XJsZKjom7y2Y2YJBRf.svg": "5313",
	"./socials/baidu.png": "116d",
	"./socials/facebook.png": "4a12",
	"./socials/line.png": "2360",
	"./socials/linkedin.png": "2b6c",
	"./socials/telegram.png": "e939",
	"./socials/viber.png": "413e",
	"./socials/vk.png": "c6ec",
	"./socials/whatsapp.png": "680c",
	"./svg-defs/arrow-left-aux.svg": "54dc",
	"./svg-defs/arrow-right-aux.svg": "059a",
	"./svg-defs/coins-dark.svg": "0e79",
	"./volunteer_uzb_country.svg": "ea9c",
	"./volunteers/2f3497b5-fd1d-4523-8b0b-7b886630c76c.jpg": "28f6",
	"./volunteers/3397ebdf-8bde-42ea-ba0f-a475c8167e27.jpg": "852d",
	"./volunteers/59a267c3-639f-4bf0-b886-7424387519f5.jpg": "b989",
	"./volunteers/Ok9M0M1MmhM.jpg": "8994",
	"./volunteers/a9f7e353-8f29-4c10-8ae4-5a9da096fa66.jpg": "7d72",
	"./volunteers/eac9af91-1a4c-4860-a136-2cf2eb0f1ae7.jpg": "76d6",
	"./volunteers/volunteer_halyk_logo.svg": "5f9f",
	"./volunteers/volunteer_kaspi_logo.svg": "91e2",
	"./volunteers/volunteer_kaz_country.svg": "0af0",
	"./volunteers/volunteer_milly_logo.svg": "b066",
	"./volunteers/volunteer_oschad_logo.svg": "71a6",
	"./volunteers/volunteer_rus_country.svg": "0833",
	"./volunteers/volunteer_sber_logo.svg": "f366",
	"./volunteers/volunteer_uzb_country.svg": "b937",
	"./zpsO96_YFj-TuJx4JXAi0.svg": "04dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";